

import { CCol, CRow, CSpinner } from '@coreui/react';
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import packageService from '../../../../../service/reactQueryServices/services/packageService';
import CustomValuesHookTS from '../../../../../Hooks/CustomValuesHookTS';
import { miladyToPersianDate, numberDisplayHandler, registerWizardStorageHandling } from '../../../../../components/helper';
import { bpLogo } from '../../../../../components/images';
import moment from 'moment';
// import bpLogo from '../../../../../assets/images/BMImage.png'
// import {bpLogo} from '../../../../../assets/images/'



const InvoiceStep = () => {
    const { mutateAsync: getInvoiceDetail, isLoading: getInvoiceDetailPendeng } = useMutation("getInvoiceDetail", packageService.getInvoiceDetail);

    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [localStates, setLocalStates] = CustomValuesHookTS<any>({ selectedGateway: "mellat" })
    const formRef = useRef<HTMLFormElement>(null);
    useEffect(() => {

        if (location.state?.upgradeResult?.invoiceid) {
            handleGetInvoiceDetail()
        }
    }, [])

    const handleGetInvoiceDetail = async () => {
        try {
            const response = await getInvoiceDetail(location.state?.upgradeResult.invoiceid)
            if (response.status === 200) {
                setLocalStates({ invoiceDetail: response.data })
            }
        } catch (error) {
            console.log(error)
        }

    }

    const { t, i18n } = useTranslation()

    const handleSendToBankGateway = () => {

        if (formRef.current) {
            const info = {
                user: location.state?.userInfo,
                boughtPackage: location.state?.boughtPackage,
                invoiceDetail: localStates.invoiceDetail,
                packageId: params.packageId, durationId: params.durationId,
                date: moment(new Date()).format('YYYY-MM-DD HH:MM')
            }
            // localStorage.setItem("invoice", JSON.stringify(info))
            registerWizardStorageHandling(3, "invoiceStepStep", { ...info, tabId: window.history?.state.key })

            formRef.current.submit();
        }
    }

    const handleDisplayPackageInfo = (type: string) => {
        if (type === "duration") {
            const durationTitle = location.state?.duration === "Month" ? t("PACKGE.MONTHLY") : t("PACKGE.YEARLY")
            return durationTitle

        } else {
            return i18n.language === 'fa' ? location.state?.boughtPackage.packageTypeTitleFa : location.state?.boughtPackage.packageTypeTitleEn
        }
    }

    return (
        <div className='mt-3' >
            <div>
                <div className='mt-2 mb-2'>
                    <div className='general-page-title' >{t("STEPS.INVOICE")}</div>

                    <p>{t("DESCRIPTION.INVOICE_STEP")}</p>

                </div>
                <div>
                    <CRow>
                        <CCol lg={6} sm={6} xs={12} className='invoice-panel-item' ><div>
                            <h2>{t("TITLES.CUSTOMER_INFO")}</h2>
                            <ul>
                                <li><label>{t("TITLES.CUSTOMER_TYPES")}</label> <span>{location.state?.userInfo?.firstName} {location.state?.userInfo?.lastName}</span></li>
                                <li><label>{t("EMAIL")}</label> <span className='email-context' title={location.state?.userInfo?.email}>{location.state?.userInfo?.email}</span></li>
                                <li><label>{t("PHONE_NUMBER")}</label> <span className='mobile-spn'>{numberDisplayHandler(location.state?.userInfo?.phoneNumber.slice(1), i18n)}</span></li>

                            </ul>
                        </div></CCol>
                        <CCol lg={6} sm={6} xs={12} className='invoice-panel-item' ><div>
                            <h2>{t("TITLES.ORDER_DETAILS")}</h2>
                            <ul>
                                <li><label>{t("TITLES.PACKAGE_NAME")}</label> <span>{handleDisplayPackageInfo("packageName")}</span></li>
                                <li><label>{t("DURATION_INVOICE")}</label> <span>{handleDisplayPackageInfo("duration")}</span></li>


                            </ul>
                        </div></CCol>
                        <CCol lg={6} sm={6} xs={12} className='invoice-panel-item' ><div>
                            <h2>{t("TITLES.INVOICE_DETAILS")}</h2>
                            {localStates.invoiceDetail && <ul>
                                <li><label>{t("TITLE.SIPONLINE.INVOICE")}</label> <span>{numberDisplayHandler(localStates.invoiceDetail.extraInfo.invoiceid, i18n)}</span></li>
                                <li><label>{t("TITLES.INVOICE_DATE")}</label> <span>{
                                    i18n.language === 'fa' ?
                                        numberDisplayHandler(miladyToPersianDate(localStates.invoiceDetail.extraInfo.date, 'YYYY-MM-DD', 'jYYYY/jMM/jDD'), i18n) : localStates.invoiceDetail.extraInfo.date}</span></li>
                                <li><label>{t("TITLES.INVOICE_DUE_DATE")}</label> <span>---</span></li>
                                <li><label>{t("TITLES.PACKAGE_PRICE")}</label> <span> {i18n.language === 'fa' ? "تومان" : ""} {numberDisplayHandler(Intl.NumberFormat().format(localStates.invoiceDetail.extraInfo.items.item[0].amount / 10), i18n)} </span></li>
                                <li><label>10% {t("TITLES.TAX")}</label> <span>{i18n.language === 'fa' ? "تومان" : ""}  {numberDisplayHandler(Intl.NumberFormat().format(localStates.invoiceDetail.extraInfo.tax / 10), i18n)}</span></li>
                                <li><label>{t("TITLES.DISCOUNT")}</label> <span>0</span></li>
                                <li className='total-amount'><label>{t("TILTES.TOTAL_PRICE")}</label> <span> {i18n.language === 'fa' ? "تومان" : ""} {numberDisplayHandler(Intl.NumberFormat().format(localStates.invoiceDetail.extraInfo.total / 10), i18n)}</span></li>

                            </ul>}
                            {getInvoiceDetailPendeng && <div className='d-flex justify-content-center' ><CSpinner /></div>}
                        </div></CCol>
                        <CCol lg={6} sm={6} xs={12} className='invoice-panel-item' ><div>
                            <h2>{t("TITLES.BANK_GATEWAY")}</h2>
                            <div className={`gateway-images ${localStates.selectedGateway === "mellat" ? "selected" : ""}`} onClick={() => setLocalStates({ selectedGateway: localStates.selectedGateway === "mellat" ? "" : "mellat" })}>
                                {localStates.invoiceDetail && localStates.invoiceDetail?.extraInfo?.status === "Unpaid" && <div >
                                    <img src={bpLogo} />

                                </div>}
                            </div>
                        </div></CCol>


                    </CRow>
                </div>

                {localStates.invoiceDetail && localStates.invoiceDetail?.extraInfo?.status === "Unpaid" &&
                    <div className="d-flex justify-content-end mt-3" >
                        <form className="btn-custom" onSubmit={handleSendToBankGateway} method="post" ref={formRef} action={process.env.REACT_APP_BANK_GATEWAY}>
                            <input type="hidden" name="invoiceid" value={localStates.invoiceDetail?.extraInfo?.invoiceid} />
                            <input type="hidden" name="amount" value={localStates.invoiceDetail?.extraInfo?.total} />
                            <input type="hidden" name="email" value={location.state?.userInfo?.email} />
                            <input type="hidden" name="currencies" value="rial" />
                            <button type='submit' className="btn btn-primary auth-form-btn" disabled={localStates.selectedGateway !== "mellat"}
                            >  {t('ACTIONS.PURCHASE_COMPLETION')}</button>
                        </form>

                    </div>}

            </div>
        </div>

    )
}

export default InvoiceStep